/* eslint-disable @typescript-eslint/no-unused-vars */
import "./styles/ModalStyle.scss";
import ModalRoute from "./ModalRoute";
import { Button, Modal } from "react-bootstrap";
import { RouteComponentProps, useHistory, useLocation } from "react-router-dom";
import React, {
  Dispatch,
  ErrorInfo,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { setModalPath } from "./utils";

type Nodes = ReactNode | ReactNode[];
interface ErrorProps extends Partial<RouteComponentProps> {
  children: Nodes;
}
interface InnerErrorProps {
  hasError: boolean;
  setHasError: Dispatch<SetStateAction<boolean>>;
  children: Nodes;
  navigate: () => void;
}
interface State {
  hasError: boolean;
}

function ModalBoundary({ children }: ErrorProps) {
  const [hasError, setHasError] = useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.key]);

  const navigateback = () => {
    setModalPath({path: undefined, history: history})
  };

  return (
    <InnerErrorBoundary hasError={hasError} setHasError={setHasError} navigate={navigateback}>
      {children}
    </InnerErrorBoundary>
  );
}

export default ModalBoundary;

class InnerErrorBoundary extends React.Component<InnerErrorProps, State> {
  constructor(props: InnerErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  componentDidUpdate(
    prevProps: InnerErrorProps,
    _previousState: InnerErrorProps
  ) {
    if (!this.props.hasError && prevProps.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
    this.props.setHasError(true);
  }

  render() {
    return this.state.hasError ? (
      <ModalRoute data-testid="modal-error">
        <div className="Error">
          <Modal.Header>
            <h2>Something went wrong</h2>
          </Modal.Header>
          <Modal.Footer>
            <Button onClick={this.props.navigate}>Go back</Button>
          </Modal.Footer>
        </div>
      </ModalRoute>
    ) : (
      this.props.children
    );
  }
}
